module.exports = __webpack_public_path__ + "media/listing/large_default-ae51dfad.png";